<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true">
    <button
      toggle="visible"
      cHeaderToggler
      [cSidebarToggle]="sidebarId"
      class="ps-1"
    >
      <svg cIcon
        name="cilMenu"
        size="lg"
      ></svg>
    </button>

    <!-- todo: header nav dropdown menus  -->
    <c-header-nav class="ms-3 me-sm-4">
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav>
  </c-container>
  <c-header-divider></c-header-divider>
  <c-container [fluid]="true">
    <c-breadcrumb-router class="ms-2"></c-breadcrumb-router>
  </c-container>
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <a href
      [caret]="false"
      cDropdownToggle
      class="py-0"
    >
      <c-avatar
        cTextColor="primary"
        shape="rounded-1"
        size="md"
        src="./assets/img/avatars/avatar.jpeg"
        status="success"
      >
      </c-avatar>
    </a>
    <ul cDropdownMenu class="pt-0 pr-5 w-auto">
      <li>
        <hr cDropdownDivider/>
      </li>
      <li>
        <a [routerLink]="['/logout']" cDropdownItem>
          <svg cIcon class="me-2" name="cilLockLocked"></svg>
          Logout
        </a>
      </li>
      <li></li>
    </ul>
  </c-dropdown>
</ng-template>






